import Button from 'antd/lib/button';
import Popconfirm from 'antd/lib/popconfirm';
import message from 'antd/lib/message';
import React, { useContext, useEffect, useState } from 'react';
import { axiosGetCall, axiosPostCall } from '../../api/axiosCall';
import CommonLayout from '../../common/CommonLayout';
import DataTable from '../../common/DataTable';
import { getColumnSearchProps } from '../../common/DataTableSearchTemplate';
import { API_END_POINT, SOMETHING_WENT_WRONG } from '../../constant/constants';
import { AuthContext } from '../../context/AuthProvider';
import AddBannerImage from './AddBannerImage';
import PlusOutlined from '@ant-design/icons/PlusOutlined';
import DeleteOutlined from '@ant-design/icons/DeleteOutlined';

const TableHeader = ({ handleAddButtonClick }) => {
  return (
    <div className='flex-row justify-end flex'>
      <Button
        type='primary'
        icon={<PlusOutlined />}
        className='border-none bg-gradient-to-r from-blue-500 to-purple-600 shadow hover:shadow-md'
        onClick={handleAddButtonClick}
      >
        Add Banner
      </Button>
    </div>
  );
};

function BannerImage() {
  const [bannerImageList, setBannerImageList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { token } = useContext(AuthContext);

  useEffect(() => {
    getBannerList();
  }, []);

  async function handleBannerDelete(data) {
    try {
      const res = await axiosPostCall({
        apiEndPoint: `${API_END_POINT.DELETE_BANNER}?Bannerid=${data.bannerId}`,
        body: {},
        header: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.hideErrorFromUser) {
        message.success(res.data.message);
        getBannerList();
      } else {
        message.error(res.error.message);
      }
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
    }
  }

  const columns = [
    {
      title: 'Logo',
      width: 100,
      render: (record) => {
        return (
          <div className='h-16 w-16 rounded-full'>
            <img
              className={`rounded-full h-16 w-16 `}
              src={record.bannerImage}
              alt={record.bannerName}
            />
          </div>
        );
      },
    },
    {
      key: 'categoryName',
      title: 'Category Name',
      dataIndex: 'categoryName',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => {
        if (a.categoryName) return a.categoryName.localeCompare(b.categoryName);
      },
      ...getColumnSearchProps('categoryName'),
    },
    {
      key: 'bannerName',
      title: 'Banner Name',
      dataIndex: 'bannerName',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => {
        if (a.bannerName) return a.bannerName.localeCompare(b.bannerName);
      },
      ...getColumnSearchProps('bannerName'),
    },
    {
      title: 'Actions',
      render: (e, record) => (
        <div className='flex items-center gap-2'>
          <Popconfirm
            title='Delete Banner'
            description={`Are you sure you want to delete "${record.bannerName}"?`}
            okText='Yes, Delete'
            okType='danger'
            cancelText='Cancel'
            onConfirm={() => handleBannerDelete(record)}
          >
            <Button
              danger
              icon={<DeleteOutlined />}
            >
              Delete
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  async function getBannerList() {
    try {
      const res = await axiosGetCall({
        apiEndPoint: API_END_POINT.GET_BANNER_IMAGE,
        header: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.hideErrorFromUser) {
        setBannerImageList(res.data);
      } else {
        message.error(SOMETHING_WENT_WRONG);
      }
      setIsLoading(false);
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
    }
  }

  function handleAddButtonClick() {
    setIsModalOpen(!isModalOpen);
  }

  return (
    <CommonLayout>
      <DataTable
        title={<TableHeader handleAddButtonClick={handleAddButtonClick} />}
        isTableRowEditable={false}
        data={bannerImageList}
        columns={columns}
        isSpinning={isLoading}
        rowKey='bannerId'
      />
      <AddBannerImage
        isOpen={isModalOpen}
        handleModelClose={handleAddButtonClick}
        callback={getBannerList}
      />
    </CommonLayout>
  );
}

export default BannerImage;
